import RunPage from "components/pages/Run";
import RunNLIPage from "components/pages/RunNLI";
import RunDashPage from "components/pages/RunDash";
import { useAppSelector } from "redux/hooks";

export default function RunPageSelector() {
    const user = useAppSelector(state => state.user);

    // Guard against undefined modelInfo
    if (!user.models || user.models.length === 0 || user.modelIndex < 0 || user.modelIndex >= user.models.length) {
        return null; // Wait for model to be loaded
    }

    const modelInfo = user.models[user.modelIndex];

    if (!modelInfo) {
        return null; // Wait for model to be loaded
    }

    return modelInfo.nliConfig ? <RunNLIPage /> : modelInfo.dashConfig ? <RunDashPage /> : <RunPage />;

}